import {MobileDialog} from '#/atoms/MobileDialog';
import {useModalContext} from '#/contexts/modal-provider';
import {useWalletProvider} from '#/contexts/wallet-provider';
import {useDisconnect} from 'wagmi';

const NavItem = ({label, onClick}: {label: string; onClick: () => void}) => {
  return (
    <button className='flex justify-center py-3 border-y-[1px] bg-grayblue text-white rounded-md' onClick={onClick}>
      {label}
    </button>
  );
};

export const MobileNavigationModal = props => {
  const {close, open} = useModalContext();
  const {
    accountResult: {address},
  } = useWalletProvider();
  const {disconnect} = useDisconnect();
  const menu = [
    {
      label: 'User Profile',
      onClick: () => {
        open({name: 'CompleteUserProfileModal', props});
        close({name: 'MobileNavigationModal', props});
      },
    },
    {
      label: 'How It Works',
      onClick: () => {
        window.open(
          'https://shareland.notion.site/Shareland-Wiki-453a3562eef644beb7ffc593f48a058d',
          '_blank',
          'noopener,noreferrer',
        );
      },
    },
    ...(!address
      ? [
          {
            label: 'Log In',
            onClick: () => {
              open({name: 'LoginModal', props: {}});
            },
          },
        ]
      : [
          {
            label: 'Log out',
            onClick: () => {
              disconnect();
              close();
            },
          },
        ]),
  ];

  return (
    <MobileDialog
      title=''
      onClose={close}
      hideOnClickAway={true}
      className='pt-4 px-8 border-none top-[-36px] rounded-tl-3xl rounded-tr-3xl pb-6'
    >
      <div className='flex justify-center'>
        <div className='bg-gray-400 w-16 h-1 rounded-full' />
      </div>
      <div className='w-full mx-auto md:rounded-2xl overflow-y-auto pt-4 gap-4 flex flex-col'>
        {menu.map(item => (
          <NavItem label={item.label} onClick={item.onClick} />
        ))}
      </div>
    </MobileDialog>
  );
};
